export const version = '2.64.2';
//# sourceMappingURL=version.js.map